import { deleteRequest, get, post} from './_defaults/fetch.js';

export const getMcps = async ({params, config}) => get('/mcps', {params, ...config});
export const getMcp = async ({id, params, config}) => get(`/mcps/${id}`, {params, ...config});
export const createMcp = async ({data, config}) => post('/mcps', data, config);
export const updateMcp = async ({id, data, config}) => post(`/mcps/${id}`, data, config);
export const deleteMcp = async ({id, config}) => deleteRequest(`/mcps/${id}`, null, config);

